import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rule-config" }
const _hoisted_2 = { class: "rule-inputs ion-padding" }
const _hoisted_3 = { slot: "label" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "empty-state"
}

import { IonBackButton, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonNote, IonPage, IonText, IonTitle, IonToggle, IonToolbar, modalController, onIonViewDidEnter, onIonViewWillLeave } from '@ionic/vue';
import { computed, ref } from 'vue';
import { addCircleOutline, closeCircle, saveOutline, storefrontOutline } from 'ionicons/icons'
import { translate } from "@hotwax/dxp-components";
import ProductFilters from '@/components/ProductFilters.vue';
import AddProductFacilityGroupModal from '@/components/AddProductFacilityGroupModal.vue';
import { useStore } from 'vuex';
import { RuleService } from '@/services/RuleService';
import { generateRuleActions, generateRuleConditions, hasError, showToast } from '@/utils';
import logger from '@/logger';
import { useRouter } from 'vue-router';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUpdateShippingRule',
  props: ["ruleId"],
  setup(__props) {

const store = useStore();
const router = useRouter();

const props = __props;
const currentRule = ref({}) as any;

const configFacilities = computed(() => store.getters["util/getConfigFacilities"])
const appliedFilters = computed(() => store.getters["util/getAppliedFilters"])
const rules = computed(() => store.getters["rule/getRules"]);
const total = computed(() => store.getters["rule/getTotalRulesCount"])
const currentEComStore = computed(() => store.getters["user/getCurrentEComStore"])
const selectedSegment = computed(() => store.getters["util/getSelectedSegment"])
const facilityGroups = computed(() => store.getters["util/getFacilityGroups"])

const formData = ref({
  ruleName: '',
  isBrokeringAllowed: false,
  selectedFacilityGroups: {
    included: [],
    excluded: []
  },
  selectedConfigFacilites: [],
  areAllSelected: false
}) as any;

onIonViewDidEnter(async () => {
  emitter.on("productStoreOrConfigChanged", redirectLink);
  emitter.emit("presentLoader");
  await Promise.allSettled([store.dispatch("util/fetchFacilityGroups"), store.dispatch("util/fetchConfigFacilities")]);
  if(props.ruleId) {
    try {
      const resp = await RuleService.fetchRules({ ruleId: props.ruleId })

      if(!hasError(resp)) {
        currentRule.value = resp.data[0];

        formData.value.ruleName = currentRule.value.ruleName;
        formData.value.isBrokeringAllowed = currentRule.value.ruleActions[0]?.fieldValue === "Y" ? true : false;

        if(selectedSegment.value === "RG_SHIPPING_FACILITY") {
          const includedGroups = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FAC_GROUPS" && condition.operator === "in")
          if(includedGroups?.fieldValue === "ALL") formData.value.areAllSelected = true
          else {
            const includedGroupIds = includedGroups?.fieldValue ? includedGroups.fieldValue.split(",") : []
            formData.value.selectedFacilityGroups.included = facilityGroups.value.filter((group: any) => includedGroupIds.includes(group.facilityGroupId));

            const excludedGroups = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FAC_GROUPS" && condition.operator === "not-in")
            const excludedGroupIds = excludedGroups?.fieldValue ? excludedGroups.fieldValue.split(",") : []
            formData.value.selectedFacilityGroups.excluded = facilityGroups.value.filter((group: any) => excludedGroupIds.includes(group.facilityGroupId));
          }
        } else if(selectedSegment.value === "RG_SHIPPING_CHANNEL") {
          const facilityCondition = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FACILITIES")
          if(facilityCondition?.fieldValue === "ALL") formData.value.areAllSelected = true
          else formData.value.selectedConfigFacilites = facilityCondition?.fieldValue ?  facilityCondition.fieldValue.split(",") : [];
        }

        const currentAppliedFilters = JSON.parse(JSON.stringify(appliedFilters.value))
        currentRule.value.ruleConditions.map((condition: any) => {
          if(condition.conditionTypeEnumId === "ENTCT_ATP_FILTER") {
            if(condition.operator === "contains") {
              currentAppliedFilters["included"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
            } else {
              currentAppliedFilters["excluded"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
            }
          }
        })
        await store.dispatch('util/updateAppliedFilters', currentAppliedFilters)
      } else {
        throw resp.data
      }
    } catch(err: any) {
      logger.error(err);
    }
  }
  emitter.emit("dismissLoader");
})

onIonViewWillLeave(() => {
  formData.value = {
    ruleName: '',
    isBrokeringAllowed: false,
    selectedFacilityGroups: {
      included: [],
      excluded: []
    },
    selectedConfigFacilites: []
  }
  store.dispatch("util/clearAppliedFilters")
  emitter.off("productStoreOrConfigChanged", redirectLink);
})

async function redirectLink() {
  router.push("/shipping")
}

async function openProductFacilityGroupModal(type: string) {
  const modal = await modalController.create({
    component: AddProductFacilityGroupModal,
    componentProps: {
      type,
      selectedFacilityGroups: formData.value.selectedFacilityGroups
    }
  })

  modal.onDidDismiss().then((result: any) => {
    if(result.data?.selectedGroups) {
      formData.value.selectedFacilityGroups[type] = result.data.selectedGroups
    }
  })

  modal.present()
}

function toggleFacilitySelection(facilityId: any) {
  if(isFacilitySelected(facilityId)) {
    formData.value.selectedConfigFacilites = formData.value.selectedConfigFacilites.filter((currentFacilityId: string) => currentFacilityId !== facilityId)
  } else {
    formData.value.selectedConfigFacilites.push(facilityId)
  }
}

function isFacilitySelected(facilityId: any) {
  return formData.value.selectedConfigFacilites.includes(facilityId)
}

async function createRule() {
  if(!isRuleValid()) return;

  emitter.emit("presentLoader");

  let ruleGroup = await store.dispatch("rule/fetchRuleGroup", { groupTypeEnumId: selectedSegment.value });

  try {
    if(!ruleGroup.ruleGroupId) {
      ruleGroup = await RuleService.createRuleGroup({
        "groupTypeEnumId": selectedSegment.value,
        "productStoreId": currentEComStore.value.productStoreId,
        "statusId": "ATP_RG_ACTIVE"
      })
    }

    const params = {
      "ruleGroupId": ruleGroup.ruleGroupId,
      "ruleName": formData.value.ruleName,
      "statusId": "ATP_RULE_ACTIVE",
      "sequenceNum": total.value ? rules.value[total.value-1].sequenceNum + 1 : 1
    }

    const rule = await RuleService.createRule(params)
    await RuleService.updateRule({
      ...params,
      "ruleConditions": generateRuleConditions(rule.ruleId, selectedSegment.value === 'RG_SHIPPING_FACILITY' ? "ENTCT_ATP_FAC_GROUPS" : "ENTCT_ATP_FACILITIES", appliedFilters.value, selectedSegment.value === 'RG_SHIPPING_FACILITY' ? formData.value.selectedFacilityGroups : formData.value.selectedConfigFacilites, formData.value.areAllSelected),
      "ruleActions": generateRuleActions(rule.ruleId, "ATP_ALLOW_BROKERING", formData.value.isBrokeringAllowed, false, [])
    }, rule.ruleId);

    showToast(translate("Rule created successfully."))
    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push("/shipping");
  } catch(err: any) {
    logger.error(err);
    showToast(translate("Failed to create rule."))
  }
  emitter.emit("dismissLoader");
}

async function updateRule() {
  if(!isRuleValid()) return;

  const currentRuleConditions = JSON.parse(JSON.stringify(currentRule.value.ruleConditions));
  const updatedRuleConditions = generateRuleConditions(props.ruleId, selectedSegment.value === 'RG_SHIPPING_FACILITY' ? "ENTCT_ATP_FAC_GROUPS" : "ENTCT_ATP_FACILITIES", appliedFilters.value, selectedSegment.value === 'RG_SHIPPING_FACILITY' ? formData.value.selectedFacilityGroups : formData.value.selectedConfigFacilites, formData.value.areAllSelected);

  updatedRuleConditions.map((updatedCondition: any) => {
    const current = currentRuleConditions.find((condition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator);
    if(current) updatedCondition["conditionSeqId"] = current.conditionSeqId;
  })

  const conditionsToRemove = currentRuleConditions.filter((condition: any) => !updatedRuleConditions.some((updatedCondition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator && condition.conditionSeqId === updatedCondition.conditionSeqId))

  try {
    await RuleService.updateRule({
      ...currentRule.value,
      "ruleName": formData.value.ruleName,
      "ruleConditions": updatedRuleConditions,
      "ruleActions": generateRuleActions(props.ruleId, "ATP_ALLOW_BROKERING", formData.value.isBrokeringAllowed, true, currentRule.value.ruleActions)
    }, props.ruleId);
    showToast(translate("Rule updated successfully."))

    const removeResponses = await Promise.allSettled(conditionsToRemove.map(async (condition: any) => await RuleService.deleteCondition({ ...condition, ruleId: props.ruleId})));
    const hasFailedResponse = removeResponses.some((response: any) => response.status === 'rejected');
    if(hasFailedResponse) logger.error("Failed to delete some rule conditions.")

    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push('/shipping');
  } catch(err: any) {
    logger.error(err);
  }
}

function isRuleValid() {
  if(!formData.value.ruleName.trim()) {
    showToast(translate("Please fill in all the required fields."))
    return false;
  }

  if(selectedSegment.value === 'RG_SHIPPING_FACILITY' && !formData.value.areAllSelected && !formData.value.selectedFacilityGroups.included.length) {
    showToast(translate("Please include atleast one facility."))
    return false;
  } else if(selectedSegment.value === 'RG_SHIPPING_CHANNEL' && !formData.value.areAllSelected && !formData.value.selectedConfigFacilites.length) {
    showToast(translate("Please select atleast one channel."))
    return false;
  }

  return true;
}

function removeFacilityGroups(facilityGroupId: any, type: string) {
  formData.value.selectedFacilityGroups[type] = formData.value.selectedFacilityGroups[type].filter((group: any) => group.facilityGroupId !== facilityGroupId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBackButton), {
                slot: "start",
                "default-href": "/shipping"
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.ruleId ? _unref(translate)("Edit shipping rule") : _unref(translate)("New shipping rule")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IonCard), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle), null, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(_toDisplayString("Rule Configuration"), -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: formData.value.ruleName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.ruleName) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(_unref(translate)("Name")) + " ", 1),
                              _createVNode(_unref(IonText), { color: "danger" }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("*", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          icon: _unref(storefrontOutline)
                        }, null, 8, ["icon"]),
                        _createVNode(_unref(IonToggle), {
                          modelValue: formData.value.isBrokeringAllowed,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.isBrokeringAllowed) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("Shipping")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (selectedSegment.value === 'RG_SHIPPING_FACILITY')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_unref(translate)("Facilities")) + " ", 1),
                  _createVNode(_unref(IonText), { color: "danger" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("*", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : (selectedSegment.value === 'RG_SHIPPING_CHANNEL')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref(translate)("Channels")) + " ", 1),
                    _createVNode(_unref(IonText), { color: "danger" }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("*", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_unref(IonItem), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonToggle), {
                  modelValue: formData.value.areAllSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.areAllSelected) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectedSegment.value === "RG_SHIPPING_FACILITY" ? _unref(translate)("Select all facilities") : _unref(translate)("Select all channels")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          (selectedSegment.value === 'RG_SHIPPING_FACILITY')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (facilityGroups.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                      _createVNode(_unref(IonCard), {
                        disabled: formData.value.areAllSelected
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonItem), { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Included")) + " ", 1),
                                  _createVNode(_unref(IonText), { color: "danger" }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("*", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonButton), {
                                fill: "clear",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (openProductFacilityGroupModal('included')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(addCircleOutline),
                                    slot: "end"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.selectedFacilityGroups['included'], (group) => {
                                return (_openBlock(), _createBlock(_unref(IonChip), {
                                  outline: "",
                                  key: group.facilityGroupId
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId) + " ", 1),
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(closeCircle),
                                      onClick: ($event: any) => (removeFacilityGroups(group.facilityGroupId, 'included'))
                                    }, null, 8, ["icon", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(IonCard), {
                        disabled: formData.value.areAllSelected
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonItem), { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Excluded")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonButton), {
                                fill: "clear",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (openProductFacilityGroupModal('excluded')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(addCircleOutline),
                                    slot: "end"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.selectedFacilityGroups['excluded'], (group) => {
                                return (_openBlock(), _createBlock(_unref(IonChip), {
                                  outline: "",
                                  key: group.facilityGroupId
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId) + " ", 1),
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(closeCircle),
                                      onClick: ($event: any) => (removeFacilityGroups(group.facilityGroupId, 'excluded'))
                                    }, null, 8, ["icon", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("No facility group found for selected product store. Either change the product store or associate facility groups with the product store.")), 1)
                        ]),
                        _: 1
                      })
                    ]))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (configFacilities.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configFacilities.value, (facility) => {
                        return (_openBlock(), _createBlock(_unref(IonCard), {
                          key: facility.facilityId,
                          onClick: ($event: any) => (toggleFacilitySelection(facility.facilityId)),
                          button: "",
                          disabled: formData.value.areAllSelected
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCardHeader), null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_unref(IonCardTitle), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(facility.facilityName ? facility.facilityName : facility.facilityId), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonCardSubtitle), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(facility.facilityId), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createVNode(_unref(IonCheckbox), {
                                  checked: isFacilitySelected(facility.facilityId)
                                }, null, 8, ["checked"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("No channel found for selected product store. Either change the product store or associate channels with the product store.")), 1)
                        ]),
                        _: 1
                      })
                    ]))
              ], 64)),
          _createVNode(ProductFilters)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFab), {
        vertical: "bottom",
        horizontal: "end",
        slot: "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFabButton), {
            disabled: selectedSegment.value === 'RG_SHIPPING_FACILITY' ? !facilityGroups.value.length : !configFacilities.value.length,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (currentRule.value.ruleId ? updateRule() : createRule()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})